module.exports = __webpack_public_path__ + "static/media/video.f556a2c3.webm";